(() => {
  const SECTION_SELECTOR = '[data-cloth-family-section]';
  const RAIL_SELECTOR = '[data-cloth-family-cards], [data-simonis-family-cards]';
  const DEMO_SELECTOR = '[data-cloth-swipe-demo]';
  const ACTIVE_CLASS = 'is-demonstrating';
  const FINISHED_CLASS = 'is-finished';
  const MOBILE_QUERY = '(max-width: 749px)';
  const FINISH_DELAY_MS = 3400;
  const INITIAL_FALLBACK_DELAY_MS = 550;

  if (window.__clothFamilySwipeDemoBound) return;
  window.__clothFamilySwipeDemoBound = true;

  const mediaQuery = window.matchMedia ? window.matchMedia(MOBILE_QUERY) : null;
  let observer = null;

  function isMobile() {
    return !mediaQuery || mediaQuery.matches;
  }

  function getDemo(section) {
    return section ? section.querySelector(DEMO_SELECTOR) : null;
  }

  function getRail(section) {
    return section ? section.querySelector(RAIL_SELECTOR) : null;
  }

  function finishDemo(section, markShown = true) {
    const demo = getDemo(section);
    if (!demo) return;

    demo.classList.remove(ACTIVE_CLASS);
    demo.classList.add(FINISHED_CLASS);
    if (markShown) section.dataset.clothSwipeDemoShown = 'true';
  }

  function startDemo(section) {
    const demo = getDemo(section);
    if (!demo || section.dataset.clothSwipeDemoShown === 'true' || !isMobile()) return;

    section.dataset.clothSwipeDemoShown = 'true';
    demo.classList.remove(FINISHED_CLASS);
    demo.classList.remove(ACTIVE_CLASS);

    let activated = false;
    const activate = () => {
      if (activated || demo.classList.contains(FINISHED_CLASS)) return;
      activated = true;
      demo.classList.add(ACTIVE_CLASS);
    };

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(activate);
    });
    window.setTimeout(activate, 80);

    window.setTimeout(() => finishDemo(section), FINISH_DELAY_MS);
  }

  function isNearViewport(section) {
    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight + 100 && rect.bottom > -100;
  }

  function getSections(root = document) {
    const sections = [];
    if (root.matches && root.matches(SECTION_SELECTOR)) sections.push(root);
    root.querySelectorAll(SECTION_SELECTOR).forEach((section) => sections.push(section));
    return sections;
  }

  function startVisibleSections(root = document) {
    getSections(root).forEach((section) => {
      if (isNearViewport(section)) startDemo(section);
    });
  }

  function bindInteractionDismiss(section) {
    const rail = getRail(section);
    if (!rail || rail.dataset.clothSwipeDemoDismissBound === 'true') return;
    rail.dataset.clothSwipeDemoDismissBound = 'true';

    const dismiss = () => finishDemo(section);
    rail.addEventListener('pointerdown', dismiss, { passive: true });
    rail.addEventListener('touchstart', dismiss, { passive: true });
    rail.addEventListener('scroll', dismiss, { passive: true });
    rail.addEventListener('wheel', dismiss, { passive: true });
  }

  function observeSection(section) {
    if (!section || section.dataset.clothSwipeDemoInitialized === 'true') return;
    section.dataset.clothSwipeDemoInitialized = 'true';
    bindInteractionDismiss(section);

    if (!isMobile()) return;

    if ('IntersectionObserver' in window) {
      if (!observer) {
        observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            startDemo(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '100px 0px', threshold: 0.05 });
      }

      observer.observe(section);
    } else if (isNearViewport(section)) {
      startDemo(section);
    }
  }

  function initialize(root = document) {
    getSections(root).forEach(observeSection);

    if (isMobile()) {
      window.setTimeout(() => startVisibleSections(root), INITIAL_FALLBACK_DELAY_MS);
    }
  }

  if (mediaQuery) {
    const handleMediaChange = () => {
      if (!isMobile()) {
        getSections(document).forEach((section) => finishDemo(section, false));
        return;
      }

      initialize(document);
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleMediaChange);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(handleMediaChange);
    }
  }

  document.addEventListener('DOMContentLoaded', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  if (document.readyState !== 'loading') initialize(document);
})();
